import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useIntl } from "react-intl";

// The Advanced tab's options that only a Modern (voice) survey uses: the open-text
// screen's Record button (text + colours, like the Back / Next / Submit rows
// above it) and the voice orb's colour. Unset → the runner's own defaults.
//
// `openColorPicker(event, current, key, onChange)` is the builder's picker.
export default function ModernStyleFields({ settings, onChange, openColorPicker }) {
    const intl = useIntl();
    const swatch = (key, value, fallback, title) => (
        <Box
            data-testid={`swatch-${key}`}
            sx={{
                width: "30px",
                height: "30px",
                backgroundColor: value || fallback,
                border: "2px solid #e0e0e0",
                borderRadius: "4px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": { transform: "scale(1.05)", boxShadow: "0 2px 6px rgba(0,0,0,0.2)" },
            }}
            onClick={(event) => openColorPicker(event, value || fallback, key, (color) => onChange(key, color))}
            title={title}
        />
    );
    const backgroundLabel = intl.formatMessage({ id: "survey_builder.modern_background_color", defaultMessage: "Background Color" });
    const fontLabel = intl.formatMessage({ id: "survey_builder.modern_font_color", defaultMessage: "Font Color" });

    return (
        <Box data-testid="modern-style-fields" sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: "text.secondary" }}>
                {intl.formatMessage({ id: "survey_builder.modern_style_heading", defaultMessage: "Modern interview" })}
            </Typography>

            {/* Record button */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <TextField
                    label={intl.formatMessage({ id: "survey_builder.record_button", defaultMessage: "Record" })}
                    value={settings.recordButtonText || ""}
                    placeholder={intl.formatMessage({ id: "voice_survey.record", defaultMessage: "Record" })}
                    onChange={(e) => onChange("recordButtonText", e.target.value)}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        width: "120px",
                        "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "white" },
                        "& .MuiInputLabel-root": { fontSize: "0.8rem" },
                    }}
                />
                <Box sx={{ display: "flex", gap: 1 }}>
                    {swatch("recordButtonBackgroundColor", settings.recordButtonBackgroundColor, "#128049", backgroundLabel)}
                    {swatch("recordButtonFontColor", settings.recordButtonFontColor, "#ffffff", fontLabel)}
                </Box>
            </Box>

            {/* Voice orb */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography sx={{ width: "120px", fontSize: "0.85rem" }}>
                    {intl.formatMessage({ id: "survey_builder.voice_orb_color", defaultMessage: "Voice orb" })}
                </Typography>
                {swatch(
                    "voiceOrbColor",
                    settings.voiceOrbColor,
                    "#2ea3ff",
                    intl.formatMessage({ id: "survey_builder.voice_orb_color", defaultMessage: "Voice orb" })
                )}
            </Box>
        </Box>
    );
}
